import { Editor } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import {
  AlignCenter,
  AlignLeft,
  AlignRight,
  PanelLeftClose,
  PanelRightClose,
  Trash2,
} from 'lucide-react';
import {
  BubbleBar,
  BubbleSep,
  BubbleIconButton,
  BubbleTextButton,
} from '../components/BubbleMenuPrimitives.tsx';
import {
  IMAGE_WIDTH_PRESETS,
  MAX_IMAGE_WIDTH,
  probeImageWidth,
} from './imageSizing.ts';
import { ImageAlign } from './imageAlign.ts';

const ImageBubbleMenu = ({ editor }: { editor: Editor }) => {
  const setWidth = (width: number) =>
    editor.chain().focus().updateAttributes('templateImage', { width }).run();

  const setAlign = (align: ImageAlign) =>
    editor.chain().focus().updateAttributes('templateImage', { align }).run();

  // "Oryginał" = natural width, capped at MAX_IMAGE_WIDTH so it can't re-blow
  // the layout. Falls back to the cap if the image can't be probed.
  const setOriginal = () => {
    const src = editor.getAttributes('templateImage').src as string | undefined;
    if (!src) {
      setWidth(MAX_IMAGE_WIDTH);
      return;
    }
    probeImageWidth(src, MAX_IMAGE_WIDTH).then(setWidth);
  };

  return (
    <BubbleMenu
      editor={editor}
      pluginKey="imageBubbleMenu"
      shouldShow={({ editor: e }) => e.isActive('templateImage')}
      options={{ placement: 'top', offset: 8 }}
    >
      <BubbleBar>
        {IMAGE_WIDTH_PRESETS.map((preset) => (
          <BubbleTextButton
            key={preset.width}
            title={`Szerokość ${preset.width}px`}
            onClick={() => setWidth(preset.width)}
          >
            {preset.label}
          </BubbleTextButton>
        ))}
        <BubbleTextButton title="Rozmiar oryginalny" onClick={setOriginal}>
          Oryginał
        </BubbleTextButton>

        <BubbleSep />

        <BubbleIconButton
          title="Wyrównaj do lewej"
          onClick={() => setAlign('left')}
        >
          <AlignLeft size={16} />
        </BubbleIconButton>
        <BubbleIconButton title="Wyśrodkuj" onClick={() => setAlign('center')}>
          <AlignCenter size={16} />
        </BubbleIconButton>
        <BubbleIconButton
          title="Wyrównaj do prawej"
          onClick={() => setAlign('right')}
        >
          <AlignRight size={16} />
        </BubbleIconButton>

        <BubbleSep />

        <BubbleIconButton
          title="Owijaj tekstem z lewej"
          onClick={() => setAlign('wrap-left')}
        >
          <PanelLeftClose size={16} />
        </BubbleIconButton>
        <BubbleIconButton
          title="Owijaj tekstem z prawej"
          onClick={() => setAlign('wrap-right')}
        >
          <PanelRightClose size={16} />
        </BubbleIconButton>

        <BubbleSep />

        <BubbleIconButton
          title="Usuń grafikę"
          danger
          onClick={() => editor.chain().focus().deleteSelection().run()}
        >
          <Trash2 size={16} />
        </BubbleIconButton>
      </BubbleBar>
    </BubbleMenu>
  );
};

export default ImageBubbleMenu;
